import React from "react";
import { Stack } from "expo-router";

/**
 * Layout component for the Admin Test section.
 * Provides stack navigation across test harnesses and diagnostic dashboards.
 */
export default function TestLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ title: "Test Tools" }} />
      <Stack.Screen name="test-alert" options={{ title: "Test Alert System" }} />
      <Stack.Screen name="test-media" options={{ title: "Test Media Storage" }} />
      <Stack.Screen name="test-auth" options={{ title: "Test Auth State" }} />
      <Stack.Screen name="test-functions" options={{ title: "Test Functions" }} />
      <Stack.Screen name="test-secure-store" options={{ title: "Test Secure Store" }} />
      <Stack.Screen name="test-firestore" options={{ title: "Test Firestore" }} />
      <Stack.Screen name="test-webbadge" options={{ title: "Test Web Badge" }} />
      <Stack.Screen name="helloworld" options={{ title: "Hello World" }} />
      <Stack.Screen name="tabtwo" options={{ title: "Tab Two" }} />
    </Stack>
  );
}
